import React from 'react';

import { Treatment as BaseTreatment } from 'src/components/user/components';
import BaseComponent from 'src/components/BaseComponent';

import model from './model';
import NavigationButtons from './NavigationButtons';

export default class Treatments extends BaseComponent {
  bottomRef = null;
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  render() {
    const { invalid, loading, error, errorMessage } = model.getApiState('updateTreatments');
    return (
      <>
        <div
          className='mc-modal-body'
          style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}
        >
          {!!error && <p className='mc-error'>{errorMessage}</p>}
          <div className='mc-form'>
            <div className={'mc-flex-15-col'}>
              <BaseTreatment
                treatments={model.input('treatments')}
                handleChange={model.handleChangeProfile}
                handleBlur={model.handleBlur}
                invalid={invalid}
                defaultTreatments={model.defaultTreatments}
                description='Enter the treatment or procedure offered and its corresponding cost.'
              />
            </div>
          </div>
        </div>
        <NavigationButtons
          hide={this.props.close}
          prev={this.props.prev}
          next={() => model.saveTreatments((err) => !err && this.props.next())}
          loading={loading}
        />
      </>
    );
  }
}
